import React from "react";

export default class AdminMenu extends React.Component {
  state = { menu: {} };

  // 🔹 Load JSON file
  handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const data = JSON.parse(event.target.result);
        this.setState({ menu: data });
      } catch {
        alert("Invalid JSON file");
      }
    };

    reader.readAsText(file);
  };

  // 🔹 Save JSON file
  saveToFile = () => {
    const dataStr = JSON.stringify(this.state.menu, null, 2);

    const blob = new Blob([dataStr], {
      type: "application/json"
    });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "menu.json";
    a.click();

    URL.revokeObjectURL(url);
  };

  // 🔹 Handle changes
  handleChange = (section, index, field, value) => {
    const menu = { ...this.state.menu };
    menu[section][index][field] = value;
    this.setState({ menu });
  };

  handlePrice = (section, index, type, value) => {
    const menu = { ...this.state.menu };
    if (!menu[section][index].price) {
      menu[section][index].price = {};
    }
    menu[section][index].price[type] = value;
    this.setState({ menu });
  };

  // 🔹 Add item
  addItem = (section) => {
    const menu = { ...this.state.menu };
    menu[section].push({
      id: Date.now(),
      name: "",
      price: {}
    });
    this.setState({ menu });
  };

  // 🔹 Delete item
  deleteItem = (section, index) => {
    const menu = { ...this.state.menu };
    menu[section].splice(index, 1);
    this.setState({ menu });
  };

  // 🔹 Add section
  addSection = () => {
    const name = prompt("Enter section name");
    if (!name) return;

    const menu = { ...this.state.menu };
    if (!menu[name]) {
      menu[name] = [];
      this.setState({ menu });
    }
  };

  render() {
    return (
      <div className="container">
        <h1 className="title">Menu Editor</h1>

        {/* Top Controls */}
        <div className="top-bar">
          <input type="file" accept=".json" onChange={this.handleFileUpload} />
          <button onClick={this.saveToFile}>💾 Download JSON</button>
          <button onClick={this.addSection}>+ Add Section</button>
        </div>

        {/* Sections */}
        {Object.keys(this.state.menu).map((section) => (
          <div className="section-card" key={section}>
            
            <div className="section-header">
              <h2>{section}</h2>
              <button onClick={() => this.addItem(section)}>
                + Add Item
              </button>
            </div>

            {this.state.menu[section].map((item, i) => (
              <div className="menu-row" key={item.id}>
                
                <input
                  className="name"
                  placeholder="Item name"
                  value={item.name}
                  onChange={(e) =>
                    this.handleChange(section, i, "name", e.target.value)
                  }
                />

                <input
                  placeholder="Mini"
                  value={item.price?.mini || ""}
                  onChange={(e) =>
                    this.handlePrice(section, i, "mini", e.target.value)
                  }
                />

                <input
                  placeholder="Regular"
                  value={item.price?.regular || ""}
                  onChange={(e) =>
                    this.handlePrice(section, i, "regular", e.target.value)
                  }
                />

                <input
                  placeholder="Full"
                  value={item.price?.full || ""}
                  onChange={(e) =>
                    this.handlePrice(section, i, "full", e.target.value)
                  }
                />

                <button
                  className="delete"
                  onClick={() => this.deleteItem(section, i)}
                >
                  ✕
                </button>

              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }
}